import React from 'react';

import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

import {
  appName,
  getTypeOfUser,
  ServiceTypes,
  TypeOfUser,
} from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';

import strings from '../../localization';
import CustomButton from '../common/CustomButton';
import { Constants } from '../../helpers/Constants';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { resetDialog } from '../../reducers/dialogReducer';
import { ReactComponent as WelcomeToPharmaGapIcon } from '../../assets/svg/pharmagapWelcome.svg';
import { ReactComponent as WelcomeToPharmaPlanIcon } from '../../assets/svg/pharmaplanWelcome.svg';

import { useAppSelector } from '../../hooks/useAppSelector';

import styles from './styles';

const { pharmacy } = TypeOfUser;
const serviceType = ServiceHandler.getService();
const isSelfService = serviceType === ServiceTypes.self;

const WelcomeToPharmaGap = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const userType = useAppSelector(getTypeOfUser);
  const isPharmacy = userType === pharmacy;

  const close = () => {
    dispatch(resetDialog());
  };

  const navigateToBilling = () => {
    navigate(Constants.paths.profile);
    close();
  };

  const navigateToPharmacyBilling = () => {
    navigate(Constants.paths.pharmacyBilling);
    close();
  };

  const config = () => {
    if (isPharmacy) {
      return {
        primary: navigateToPharmacyBilling,
        title: strings.welcomeToPharmaGap,
        description: strings.pleaseSelectAndAddCardDetails,
        primaryLabel: strings.proceed,
        style: styles.proceed,
      };
    }

    return {
      primary: navigateToBilling,
      title: strings.formatString(
        strings.thankYouForJoiningPlatform,
        appName[serviceType],
      ),
      description: isSelfService
        ? strings.welcomeToPharmaGapSubMessage
        : strings.welcomeToPharmaPlanSubMessage,
      primaryLabel: strings.setupMyProfile,
      style: styles.updateProfile,
    };
  };

  const { primary, title, description, primaryLabel, style } = config();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.icon}>
        {isSelfService ? <WelcomeToPharmaGapIcon /> : <WelcomeToPharmaPlanIcon />}
      </Box>
      <Typography sx={[styles.title, styles.textAlign]}>{title}</Typography>
      <Typography sx={[styles.description, styles.textAlign]}>
        {description}
      </Typography>

      <Box sx={styles.buttonContainer}>
        <CustomButton
          label={primaryLabel}
          customButtonStyle={style}
          onClick={primary}
        />
      </Box>
    </Box>
  );
};

export default WelcomeToPharmaGap;
